import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './components/Home';
import About from './components/About';
import Gallery from './components/Gallery';
import Blog from './components/Blog';
import Contact from './components/Contact';
import FertilityEnhancingSurgery from './components/treatments/FertilityEnhancingSurgery';
import LaparoscopicHysterectomy from './components/treatments/LaparoscopicHysterectomy';
import LaparoscopicMyomectomy from './components/treatments/LaparoscopicMyomectomy';
import HighRiskPregnancy from './components/treatments/HighRiskPregnancy';
import InfertilityEvaluation from './components/treatments/InfertilityEvaluation';
import IntrauterineInsemination from './components/treatments/IntrauterineInsemination';
import IVFandICSI from './components/treatments/IVFandICSI';
import MaleInfertility from './components/treatments/MaleInferility';

function App() {
  return (
    <Router>
      <header className="bg-neutral text-white shadow-xl">
        <div className="section-container flex flex-wrap items-center justify-between gap-4 py-5">
          <Link to="/">
            <img src="/Dr_Priya_Bhave_Logo.png" alt="Dr. Priya Bhave Chittawar Logo" className="h-32 md:h-40" />
          </Link>
          <Navigation />
        </div>
      </header>

      <main className="bg-neutral/5">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/treatments/fertility-enhancing-surgery" element={<FertilityEnhancingSurgery />} />
          <Route path="/treatments/laparoscopic-hysterectomy" element={<LaparoscopicHysterectomy />} />
          <Route path="/treatments/laparoscopic-myomectomy" element={<LaparoscopicMyomectomy />} />
          <Route path="/treatments/high-risk-pregnancy" element={<HighRiskPregnancy />} />
          <Route path="/treatments/infertility-evaluation" element={<InfertilityEvaluation />} />
          <Route path="/treatments/intrauterine-insemination" element={<IntrauterineInsemination />} />
          <Route path="/treatments/ivf-icsi" element={<IVFandICSI />} />
          <Route path="/treatments/male-infertility" element={<MaleInfertility />} />
        </Routes>
      </main>

      <Footer />
    </Router>
  );
}

export default App;
